export default __webpack_public_path__ + "static/RunLeft2-732988ef37c7ccc443103eb5a67a1e81.mp3";